import { icons } from "@bruntworkwear-apps/ui";
import styles from "../PoTable.module.css";

interface PoToggleProps {
  po: string;
  isOpen: boolean;
  onToggle: () => void;
}

/**
 * Opens an order's breakdown.
 *
 * A control in the cell rather than a click anywhere on the row: whole-row
 * clicking belongs to the design system's DataTable, and this app should not
 * reimplement the table to get it. A private sub-view of PoTable.
 */
export function PoToggleView({ po, isOpen, onToggle }: PoToggleProps) {
  return (
    <button
      type="button"
      className={[styles.toggle, isOpen && styles.toggleOpen].filter(Boolean).join(" ")}
      onClick={onToggle}
      aria-expanded={isOpen}
      aria-label={`${isOpen ? "Hide" : "Show"} the breakdown for PO ${po}`}
    >
      <icons.ChevronRight size={13} className={styles.chevron} aria-hidden />
      {po}
    </button>
  );
}
